<div class="keen-slider--container">
  @if (title) {
    <div class="section-header">
      <h2 class="section-title">{{ title }}</h2>
    </div>
  }
  <div class="navigation-wrapper">
    <div
      #sliderRef
      class="keen-slider keen-slider--vertical"
      [ngClass]="{ 'justify-content-center': slidesNumber && slidesNumber < slidesPerView }"
    >
      @for (product of productList; track product.id) {
        <div
          class="keen-slider__slide number-slide"
          [ngClass]="{ 'slide-visible': isVisibleSlide($index) }"
          [attr.aria-hidden]="!isVisibleSlide($index)"
        >
          <app-product-card
            [product]="product"
            [colorReferences]="colorReferences"
            [displaySpecificProductCampaignHighlights]="true"
            [isSlider]="true"
            [isSlideVisible]="isVisibleSlide($index)"
            (addToCart)="onAddToCart($event)"
          />
        </div>
      }
    </div>
    @if (sliderKeen && showArrows) {
      <div class="keen-slider__arrows">
        <button
          type="button"
          class="arrow arrow--left"
          [ngClass]="{ 'arrow--disabled': currentSlide === 0 }"
          (click)="prevStep()"
          (keypress)="prevStep()"
        >
          <span class="sr-only" i18n="@@pagination.previousButton">Previous</span>
          <i class="fal fa-chevron-left"></i>
        </button>
        <button
          type="button"
          class="arrow arrow--right"
          [ngClass]="{ 'arrow--disabled': activeDot === dotHelper.length - 1 }"
          (click)="nextStep()"
          (keypress)="nextStep()"
        >
          <span class="sr-only" i18n="@@pagination.NextButton">Next</span>
          <i class="fal fa-chevron-right"></i>
        </button>
      </div>
    }

    @if (sliderKeen && showDots) {
      <div class="dots">
        @for (slide of dotHelper; track slide; let i = $index) {
          <button type="button" class="dot" [ngClass]="{ active: i === activeDot }" (click)="goToSlide(i)">
            <span class="sr-only">Slider step {{ i }}</span>
          </button>
        }
      </div>
    }
  </div>
</div>
<ng-container>
  <!-- Added to Cart Modal -->
  <app-modal
    #ModalComponent
    title="Added to cart"
    i18n-title="@@product.productAddedToCart"
    [sourceId]="'offcanvas_added_to_cart_carousel_' + uniqueModalId"
    [modalClass]="'product-modal'"
  >
    <app-product-added-to-cart
      [product]="product"
      [productPrice]="product?.price"
      [productStock]="product?.stock"
      [quantity]="quantity"
      (closeModalEvent)="closeAddedToCartModal()"
    />
  </app-modal>
  <!-- Quantity Error Modal -->
  <app-modal
    #ModalErrorComponent
    i18n-title="@@product.maxQuantityErrorTitle"
    title="Quantity Error"
    [sourceId]="'quantityErrorModal' + uniqueModalId"
    [closeBackDrop]="false"
    [modalClass]="'quantity-error__modal'"
  >
    <p i18n="@@product.maxQuantityErrorTextAux">
      You have exceeded the maximum quantity of the product, a total of
      {{ MAX_ITEM_QUANTITY }} units of the product have been added.
    </p>
    <div class="quantity-error__buttons">
      <button type="button" class="btn btn-secondary" i18n="@@CLOSE" (click)="closeQuantityErrorModalCarousel()">Close</button>
    </div>
  </app-modal>
  <!-- Cart Quantity Error Modal -->
  <app-modal
    #ModalErrorComponentCartMaxValue
    i18n-title="@@product.maxCartQuantityErrorTitle"
    title="Quantity Error"
    [closeBackDrop]="true"
    [modalClass]="'quantity-error__modal'"
    [sourceId]="'quantityErrorModalCartMaxValue' + uniqueModalId"
  >
    <p i18n="@@product.maxCartQuantityErrorTextAux">
      There are too many products in your cart, please reduce the number of products selected.
    </p>
    <div class="quantity-error__buttons">
      <button type="button" class="btn btn-secondary" i18n="@@CLOSE" (click)="closeQuantityErrorCartMaxValueModal()">
        Close
      </button>
    </div>
  </app-modal>
</ng-container>
